export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FreightOrders.vue?vue&type=template&id=44bea920"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightOrders.vue?vue&type=template&id=44bea920
// module id = 2304
// module chunks = 31